// extracted by mini-css-extract-plugin
export default {"sticky":"Tab_sticky__h3Bza","fillParent":"Tab_fillParent__j0QnF","borderless":"Tab_borderless__yZ7Ge","padding":"Tab_padding__Dyvi-"};